<template>
	<div class="bar">
		<div class="bar_left">
			<div class="bar_left_optbox">
				<div class="bar_left_opt" @click="bar(0)">
					720°全景
				</div>
				<div class="bar_left_opt" @click="bar(1)">
					景区景点
				</div>
				<div class="bar_left_opt" @click="bar(2)">
					旅游指南
				</div>
				<div class="bar_left_opt" @click="bar(3)">
					旅游服务
				</div>
				<div class="bar_left_opt" @click="bar(4)">
					联系我们
				</div>
			</div>
			
			<div class="bar_left_copy">
				CopyRight © 2024 cailunjinianyuan All Rights Reserved.Design  
			</div>
			
			<div class="bar_left_by">
				<div class="bai" @click="rescue()">
					by:至上互动
				</div>
				<div class="bai" @click="ban()">
					ICP:陕ICP备0000000号
				</div>
			</div>
		</div>
		
		<div class="bar_right">
			<div class="bar_right_one">
				<div class="bar_right_sm">
					【扫一扫 关注微信公众号】
					<img class="sj_img" src="../static/home/sanjiao2.png" alt="" />
				</div>
				
				<div class="bar_right_dz">
					景区地址：湖南省耒阳市人民路蔡子池畔
				</div>
				
				<div class="bar_right_pohbox">
					<div class="bar_right_poh">
						咨询电话：0734-4332082
					</div>
					<div class="bar_right_poh">
						救援电话：0734-4289116
					</div>
					<div class="bar_right_poh">
						投诉电话：0734-4289118
					</div>
				</div>
				
				<div class="bar_right_pt" @click="nuv()">
					全国旅游监管服务平台：12345
				</div>
			</div>
			
			<div class="bar_right_tow">
				<!-- 二维码 -->
			</div>
		</div>
		
		
		<!--  -->
		<div class="riesun" v-if="riesunfalg" @click="close()">
			<div class="riesun_box">
				<img class="riesun_img" src="../static/home/riesun.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				lang:0,		//语言
				riesunfalg:false,
			}
		},
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 0
			
		},
		methods:{
			nuv(){		//服务平台
				window.open('https://jbts.mct.gov.cn/',"_blank");
			},
			ban(){		//备案
				window.open('https://beian.miit.gov.cn/#/Integrated/index',"_blank");
			},
			// 名片
			rescue(){
				this.riesunfalg = true
			},
			close(){
				this.riesunfalg = false
			},
			
			
			// 
			bar(e){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				if(e==0){	//720
					window.open('https://www.720yun.com/vr/2efjz7myra8', "_blank"); //跳转打开新界面
				}
				if(e==1){
					if(this.$route.name == 'scenery'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'scenery',query:{}})
					}
				}
				if(e==2){
					if(this.$route.name == 'guide'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'guide',query:{}})
					}
				}
				if(e==3){
					if(this.$route.name == 'serves'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'serves',query:{}})
					}
				}
				if(e==4){
					if(this.$route.name == 'contact'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'contact',query:{}})
					}
				}
				
			},
			
		}
	}
</script>

<style scoped lang="less">
	.bar{
		width: 1920px;
		height: 132px;
		background-image: url('../static/home/bar.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		cursor:pointer;
		box-sizing: border-box;
		padding: 0 58px;
		display: flex;
		justify-content: space-between;
		
		font-family: 'sy';
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 99;
	}
	
	// 
	.bar_left{
		margin-top: 48px;
		color: #c1a356;
	}
	.bar_left_optbox{
		height: 16px;
		line-height: 16px;
		display: flex;
		
	}
	.bar_left_opt{
		padding: 0 8px;
		border-right: 1px solid #c1a356;
		font-size: 14px;
		
	}
	.bar_left_opt:last-child{
		border-right: 1px solid transparent;
	}
		.bar_left_opt:hover{
			color: #fff;
		}
	// 
	.bar_left_copy{
		font-size: 12px;
		line-height: 12px;
		margin: 10px 8px;
	}
	.bar_left_by{
		font-size: 12px;
		display: flex;
		margin: 0px 8px;
	}
	.bai:hover{
		color: #fff;
	}
		
	// 
	.bar_right{
		margin-top: 22px;
		color: #c1a356;
		display: flex;
	}
	.bar_right_one{
		text-align: right;
	}
	.bar_right_sm{
		font-size: 16px;
		
		.sj_img{
			width: 11px;
			height: 13px;
		}
	}
	.bar_right_dz{
		font-size: 14px;
	}
	
	.bar_right_pohbox{
		display: flex;
		margin: 3px 0 6px 0;
	}
		.bar_right_poh{
			font-size: 14px;
			height: 16px;
			line-height: 16px;
			padding: 0 8px;
			border-right: 1px solid #c1a356;
		}
		.bar_right_poh:last-child{
			border-right: 1px solid transparent;
			padding: 0 0px 0 8px;
		}
	
	.bar_right_pt{
		font-size: 12px;
	}
	.bar_right_pt:hover{
		color: #fff;
	}
	
	// 
	.bar_right_tow{
		width: 93px;
		height: 93px;
		background-image: url(../static/home/erwei.jpg);
		background-repeat: no-repeat;
		background-size: 100% 100%;
		
		margin-left: 12px;
	}
	
	
	//
	.riesun{
		position: fixed;
		z-index: 100;
		top: 0;
		left: 0;
		width: 1920px;
		height: 100vh;
		background-color: rgba(0, 0, 0, .5);
	}
	.riesun_box{
		width: 1000px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform:translate(-50%,-50%);
		background-color: #363636;
	}
	.riesun_img{
		width: 100%;
	}
</style>